var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wifi_svg__a",
    d: "M1.854 8.854a.5.5 0 1 1-.708-.708C3.911 5.382 7.54 4 12 4c4.461 0 8.09 1.382 10.854 4.146a.5.5 0 0 1-.708.708C19.577 6.284 16.206 5 12 5S4.423 6.285 1.854 8.854zm3 4a.5.5 0 0 1-.708-.708C6.242 10.051 8.87 9 12 9s5.758 1.051 7.854 3.146a.5.5 0 0 1-.708.708C17.242 10.949 14.87 10 12 10s-5.242.949-7.146 2.854zm3 3a.5.5 0 0 1-.708-.708C8.571 13.722 10.196 13 12 13c1.804 0 3.43.722 4.854 2.146a.5.5 0 0 1-.708.708C14.904 14.61 13.53 14 12 14c-1.53 0-2.904.611-4.146 1.854zM12 20a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wifi_svg__a",
    fill: "#4A4A4A",
    transform: "translate(-1 -4)"
  })));
};
export default SvgWifi;